"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getTooltipId = void 0;
const getTooltipId = (id) => `${id}-tooltip`;
exports.getTooltipId = getTooltipId;
//# sourceMappingURL=index.js.map